// Libs
import classNames from 'classnames/bind';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel } from '@mui/material';
// Components, Layouts, Pages
// Others
import { TCheckBoxType } from '~/utils/type/common';
// Styles, images, icons
import styles from './BaseCheckbox.module.scss';
import { icons } from '~/assets';

type Props = {
  label?: string;
  checked?: boolean;
  type?: TCheckBoxType;
  disabled?: boolean;
  indeterminate?: boolean;
  onChange?: (checked: boolean) => void;
};

const cx = classNames.bind(styles);

const BaseCheckbox = (props: Props) => {
  //#region Destructuring Props
  const { label, checked = false, disabled, indeterminate, type = 'default', onChange } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  const isChecked = useMemo(() => checked, [checked]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <FormControlLabel
      id='baseCheckboxComponent'
      className={cx('formControlLabel', type)}
      slotProps={{
        typography: {
          className: cx('checkboxLabel', type),
        },
      }}
      control={
        <Checkbox
          size='small'
          icon={<img src={icons.commonIconUncheckbox} alt={t('altImg')} className={cx('checkboxIcon', type)} />}
          checkedIcon={<img src={icons.commonIconCheckbox} alt={t('altImg')} className={cx('checkboxIcon', type)} />}
          indeterminateIcon={
            <img src={icons.commonIconIndeterminate} alt={t('altImg')} className={cx('checkboxIcon', type)} />
          }
          className={cx('checkbox', disabled && 'disabled')}
          color='primary'
          checked={isChecked}
          indeterminate={indeterminate}
          onChange={(event) => onChange?.(event.target.checked)}
        />
      }
      label={label}
    />
  );
};

export default BaseCheckbox;
